import React from "react";
import { FunctionGoodsReceipt, FunctionPickPack, FunctionInventoryStatus, FunctionInventoryTransfer, FunctionInventoryCounting, FunctionDelivery } from '../icons';
export const formatNumericalWithThousandSeparator = value => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};
export const getFunctionIcon = (functionType) => {
    switch (functionType) {
        case 1:
            return React.createElement(FunctionGoodsReceipt, null);
        case 2:
            return React.createElement(FunctionPickPack, null);
        case 3:
            return React.createElement(FunctionInventoryStatus, null);
        case 4:
            return React.createElement(FunctionInventoryTransfer, null);
        case 5:
            return React.createElement(FunctionInventoryCounting, null);
        case 6:
            return React.createElement(FunctionDelivery, null);
    }
    ;
};
